import { useIsEnrolledInVariant } from './unleash/useIsEnrolledInVariant';
import useMartyContext from './useMartyContext';

import { FEATURE_MY_ACCOUNT_REDESIGN } from 'constants/features';

const useMyAccountRedesignEnabled = () => {
  const isInMyAccountRedesignTreatment = useIsEnrolledInVariant({ featureFlag: FEATURE_MY_ACCOUNT_REDESIGN, isZapposOnly: false }).isEnrolled;
  const { marketplace } = useMartyContext();
  return isInMyAccountRedesignTreatment && marketplace.hasMyAccountRedesign;
};

export default useMyAccountRedesignEnabled;
